import { render, staticRenderFns } from "./SidebarPanelContent.vue?vue&type=template&id=51edfc96&"
import script from "./SidebarPanelContent.vue?vue&type=script&lang=js&"
export * from "./SidebarPanelContent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarPanelContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports